export default __webpack_public_path__ + "static/advanced-questions-4c5779be49facb84d1fdabf27225f4ff.png";